import { useEffect, useMemo, useState } from 'react';
import '/assets/styles/partials/ticket-block-selector.scss';
import classNames from 'classnames';
import { useTranslation } from '/utilities/i18n';

// Partials
import { Input } from '/views/partials/forms';
import Btn from '/views/partials/btn';
import processSeatingPlan from '../../functions/process-seating-plan';

export const TicketBlockSelector = ({ busy, availableSlots, lockedSlots, seatPlan, selectedSlots, onChangeSelection, selectionLimit, className }) => {
	const { t } = useTranslation();
	const [addMode, setAddMode] = useState(false);

	const processedBlocks = useMemo(() => processSeatingPlan({
		seatPlan,
		availableSlots,
		lockedSlots,
		selectedSlots,
	}), [seatPlan, availableSlots, lockedSlots, selectedSlots]);

	const slotSelection = useMemo(() => {
		return [
			...selectedSlots,
			...addMode ? [null] : []
		]
	}, [selectedSlots, addMode])

	useEffect(() => {
		if(selectedSlots.length === 0) {
			setAddMode(true);
		}
	}, [selectedSlots])

	const updateSlotSelection = (newSlot, oldSlot) => {
		onChangeSelection([
			...selectedSlots.filter(slot => slot.title !== oldSlot?.title),
			newSlot,
		]);

		if(!oldSlot) {
			setAddMode(false);
		}
	}

	const deleteSlot = (slot) => {
		if(!slot) {
			setAddMode(false);
		}
		else {
			onChangeSelection(selectedSlots.filter(selectedSlot => selectedSlot.title !== slot?.title));
		}
	}

	const canAdd = !addMode && slotSelection.length < selectionLimit;
  
	return (
		<div className={classNames('ticketblockselector', className)}>
			{slotSelection.map((slot) => (
				<SlotSelector
					busy={busy}
					slot={slot}
					key={slot?.title ?? 'new-item'}
					processedBlocks={processedBlocks}
					isOnlySlot={slotSelection.length === 1}
					onDelete={() => deleteSlot(slot)}
					onUpdate={(newSlot) => updateSlotSelection(newSlot, slot)} />
			))}
			<Btn
				disabled={!canAdd}
				className="ticketblockselector-addbtn primary"
				icon="plus"
				onClick={() => { setAddMode(true) }}
				>
				{t('Koltuk Ekle')}
			</Btn>
		</div>
	);
};

const SlotSelector = ({ slot: propSlot, processedBlocks, onUpdate, busy, onDelete, isOnlySlot }) => {
	const { t } = useTranslation();
	const [selectedBlock, setSelectedBlock] = useState(null);
	const [selectedRow, setSelectedRow] = useState(null);
	const [selectedSlot, setSelectedSlot] = useState(null);

	useEffect(() => {
		if(propSlot?.title?.length) {
			const [blockId, rowId] = propSlot.title.split('-');

			const block = processedBlocks.find(block => block.value.toString() === blockId);
			const row = block?.rows?.find(row => row.value.toString() === rowId);
			const slot = row?.seats?.find(rowSlot => rowSlot.slot.title === propSlot.title);

			if(block && row && slot) {
				setSelectedBlock(block);
				setSelectedRow(row);
				setSelectedSlot(slot);
			}
		}
	}, [propSlot, processedBlocks])

	useEffect(() => {
		if(selectedSlot) {
			if(selectedSlot?.slot?.title !== propSlot?.title) {
				onUpdate(selectedSlot.slot);
			}
		}
	}, [selectedSlot, propSlot])

	return (
		<div className="ticketblockselector-group">
			<Input
				className="ticketblockselector-group-input"
				disabled={busy}
				type="select"
				label={t('Blok')}
				value={selectedBlock}
				onChange={setSelectedBlock}
				options={processedBlocks} />
			
			<Input
				className="ticketblockselector-group-input"
				type="select"
				label={t('Sıra')}
				value={selectedRow}
				onChange={setSelectedRow}
				options={selectedBlock?.rows}
				disabled={busy || !selectedBlock} />

			<Input
				className="ticketblockselector-group-input"
				type="select"
				label={t('Koltuk')}
				value={selectedSlot}
				onChange={setSelectedSlot}
				options={selectedRow?.seats}
				disabled={busy || !selectedRow} />

			<Btn
				disabled={isOnlySlot}
				className="red nude"
				icon="trash"
				onClick={onDelete}
				/>

		</div>
	)
}

export default TicketBlockSelector;